module.exports = {
  //For localhost
  // Url: 'http://localhost:4063/'
  //For staging
  // Url: 'https://api.nft.flexsin.org/'
  //for Production
  Url: 'https://api.ledex.digital/'
}